import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DocumentTitle, Page} from '../widgets';
import {FIXED_IMAGES, FIXED_IMAGES_UUIDS} from './fixedImages';
import ChooseBackground from '../widgets/ChooseBackground';
import FancyLink from '../widgets/FancyLink';
import Form from '../widgets/FormV2';
import ProgressBar from '../widgets/ProgressBar';
import sessionActions from '../user/session.actions';
import FancyButton from '../widgets/FancyButton';
import {push} from 'connected-react-router';
import getGettingStartedProgress from './gettingStartedProgress';
import {PresentationProfileImages} from './ProfileImages';
import handleError from '../handleError';
import {postFile, deleteJson} from '../fetchJson';
import uuidv4 from 'uuid/v4';
import {GettingStartedFooter} from './GettingStarted';

const getSessionProvider = props => props && props.currentSession && props.currentSession.provider;
const getSessionUser = props => props && props.currentSession && props.currentSession.user;

const getStateFromSession = (sessionUser, sessionProvider) =>
	sessionUser && sessionProvider
		? {
				backgroundImage: sessionProvider.profile.backgroundImage,
				images: sessionProvider.profile.images,
				addingProfileImage: null,
				uploadProgress: 0
				// TODO youtube?
		  }
		: {
				backgroundImage: null,
				images: [],
				addingProfileImage: null,
				uploadProgress: 0
		  };

const getDataFromState = state => ({
	user: {},
	profile: {
		backgroundImage: state.backgroundImage,
		images: state.images
	}
});

class GettingStartedImages extends Component {
	constructor(props) {
		super(props);

		this.state = getStateFromSession(getSessionUser(props), getSessionProvider(props));

		this.setBackgroundImage = val =>
			this.setState({
				backgroundImage: FIXED_IMAGES_UUIDS[FIXED_IMAGES.indexOf(val)]
			});

		this.dropProfileImage = acceptedFiles => {
			if (!acceptedFiles || !acceptedFiles[0]) return;

			const imageUuid = uuidv4();
			const provider = getSessionProvider(this.props);

			this.setState({
				addingProfileImage: acceptedFiles[0].preview,
				uploadProgress: 0
			});

			postFile(
				`/api/providers/${provider.uuid}/image/${imageUuid}?profile=true`,
				{image: acceptedFiles[0]},
				prog => this.setState({uploadProgress: prog})
			)
				.then(() => {
					this.setState({
						images: this.state.images.concat(imageUuid),
						addingProfileImage: null
					});
				})
				.catch(this.props.handleError);
		};

		this.deleteProfileImage = uuid => {
			const provider = getSessionProvider(this.props);

			deleteJson(`/api/providers/${provider.uuid}/image/${uuid}`, {}).then(() => {
				this.setState({
					images: this.state.images.filter(image => image !== uuid)
				});
			});
		};

		this.next = () => this.props.next(getDataFromState(this.state));
		this.previous = () => this.props.previous(getDataFromState(this.state));
	}

	componentWillUpdate(nextProps) {
		if (nextProps.currentSession !== this.props.currentSession) {
			this.setState(getStateFromSession(getSessionUser(nextProps), getSessionProvider(nextProps)));
		}
	}

	render() {
		if (!getSessionProvider(this.props)) return null;

		const {backgroundImage} = this.state;

		const progress = getGettingStartedProgress(
			getSessionUser(this.props),
			getSessionProvider(this.props)
		);

		return (
			<DocumentTitle title="B2Me">
				<Page className="GettingStarted scroll-anchor">
					<Form>
						<p>Choose a header background to spruce up your profile.</p>
						<div>
							<h3>Header image</h3>
							<ChooseBackground
								onSelect={this.setBackgroundImage}
								selected={
									backgroundImage &&
									FIXED_IMAGES_UUIDS.indexOf(backgroundImage) >= 0 &&
									FIXED_IMAGES[FIXED_IMAGES_UUIDS.indexOf(backgroundImage)]
								}
								items={FIXED_IMAGES}
							/>
						</div>
						<div>
							<label>
								<h3>Profile image gallery</h3>
								<p>
									Add photos to your gallery to help your profile stand out, and give people a
									better idea of what you do.
								</p>
								<PresentationProfileImages
									profile={{
										profile: {
											images: this.state.images,
											youtubeVideos: []
										},
										subscriptionLevel: 'free', // TODO??
										user: this.props.currentSession ? this.props.currentSession.user : undefined
									}}
									sessionProvider={
										this.props.currentSession ? this.props.currentSession.provider : undefined
									}
									editable={true}
									isAdmin={false}
									dropProfileFile={this.dropProfileImage}
									deleteImage={this.deleteProfileImage}
								/>
							</label>
						</div>
						<GettingStartedFooter
							progress={progress}
							subscriptionLevel={'essential'}
							next={this.next}
							previous={this.previous}
							nextLabel="Build my profile"
						/>
					</Form>
				</Page>
			</DocumentTitle>
		);
	}
}

const ConnectedGettingStartedImages = connect(
	({session, categories}) => ({
		categories: categories && categories.provider,
		currentSession: session && session.current
	}),
	dispatch => ({
		previous: data => {
			dispatch(sessionActions.persistSessionField(data));
			dispatch(push('/getting-started-community')); // TODO depends on whether signing up with a community or not
		},
		next: data => {
			dispatch(sessionActions.persistSessionField(data));
			dispatch(push('/getting-started-building'));
		},
		handleError: handleError(dispatch)
	})
)(GettingStartedImages);

export default ConnectedGettingStartedImages;



// WEBPACK FOOTER //
// ./src/profile/GettingStartedImages.js